import React from "react";
import ReactDOM from "react-dom/client";
import Tracking from "./modules/tracking";
import {ThemeProvider} from "@mui/material";
import {theme} from "./styles/theme";
import {initReactI18next} from "react-i18next";
import i18n from "i18next";
import {Provider} from "react-redux";
import store from "./modules/store/store";

const rootElement = document.getElementById("react-tracking") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);


const init = (lang: string) => {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      // the translations
      // (tip move them in a JSON file and import them,
      // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
      resources: {
        en: {
          translation: {
            track: "Track",
            inputPlaceholder: "Enter tracking number",
            trackingNumber: "Tracking number",
            nothingFound: {
              title: "Nothing found",
              description: "Check your tracking number and try again",
            },
            events: {
              shipped: "Shipped",
              delivered: "Delivered",
            },
            error: {
              title: "An error occurred",
              description: "Please try again later",
            },
          },
        },
        ru: {
          translation: {
            track: "Отследить",
            inputPlaceholder: "Введите номер отслеживания",
            trackingNumber: "Номер отслеживания",
            nothingFound: {
              title: "Ничего не найдено",
              description: "Проверьте номер отслеживания и попробуйте ещё раз",
            },
            events: {
              shipped: "Отправлено",
              delivered: "Получено",
            },
            error: {
              title: "Произошла ошибка",
              description: "Пожалуйста, повторите попытку позже",
            },
          },
        },
        ua: {
          translation: {
            track: "Відстежити",
            inputPlaceholder: "Введіть номер відстеження",
            trackingNumber: "Номер відстеження",
            nothingFound: {
              title: "Нічого не знайдено",
              description: "Перевірте номер відстеження та спробуйте ще раз",
            },
            events: {
              shipped: "Відправлено",
              delivered: "Отримано",
            },
            error: {
              title: "Виникла помилка",
              description: "Будь-ласка спробуйте пізніше",
            },
          },
        },
      },
      debug: true,
      lng: lang,
      fallbackLng: "en",

      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      },
    })
    .then(() => {
    })
    .catch((error) => {
      console.log(error);
    });
};

init(rootElement?.dataset?.lang ?? "en");


root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <Tracking />
    </ThemeProvider>
  </Provider>,
);

